export default class EventBus {
    constructor() {
        this.listeners = {}
    }

    emit(event, ...values) {
        if (this.listeners[event]) {
            for (let listener of this.listeners[event]) {
                if (listener(...values) === true)
                    return true
            }
        }
        return false
    }

    on(event, callable) {
        if (!this.listeners[event]) {
            this.listeners[event] = []
        }

        this.listeners[event].push(callable)
        return callable
    }

    removeListener(event, callable) {
        if (this.listeners[event]) {
            this.listeners[event] = this.listeners[event].filter(c => c !== callable)
        }
    }
}